export const discover: Record<string, string> = {
  'Discover': 'Otkrij',
  'Trending trade ideas from the community': 'Trejd ideje u trendu iz zajednice',
  'Failed to load': 'Učitavanje nije uspelo',
  // 'Failed to load feed', 'Failed to load trades', 'Retry', 'Be the first…', 'Clear Filters', 'Load more' already live in feed.ts
  'Nothing to discover yet': 'Još nema ničeg za otkrivanje',
  "You've reached the end": 'Stigao si do kraja',
  'Refresh': 'Osveži',
};
